import { insertAbout } from "javascripts/webpage/insert-about";

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector("#js-hotels.hotels-index") && !document.querySelector("#js-hotels-spec-index")) {
    return;
  }
  insertAbout();
});
